/** Only React business routes get the public shell. Authentication, public
 * verification, Odoo, downloads and provider callbacks always use the network. */
const APP_ROUTES = new Set([
    "requests", "projects", "portfolios", "boq", "payments", "letters", "meetings",
    "committees", "hse", "handover", "archive", "reports", "report-builder", "email",
    "dashboard", "design-dashboard", "executive", "staff", "contracts", "timeline",
    "offline", "announcements", "discuss", "manual", "ai", "settings", "workflow", "r",
]);
const CALLBACK_PARAMS = ["code", "state", "token", "access_token", "id_token", "error", "session_state"];

export function isAppNavigation(url: URL) {
    return (url.pathname === "/" || APP_ROUTES.has(url.pathname.split("/")[1] ?? ""))
        && !CALLBACK_PARAMS.some((key) => url.searchParams.has(key));
}
